
<script setup>
import { defineProps } from 'vue';

defineProps({
    navigate: {
        type: Function,
        required: true
    }
});
</script>

<template>
    <footer class="bg-gray-50 pt-12 pb-6 border-t border-gray-200 mt-auto">
        <div class="container mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-gray-600">
            <!-- Logo & Motto -->
            <div>
                <div class="flex items-center space-x-2 mb-4">
                    <span class="text-gray-800 text-lg font-semibold">Swif Study Abroad</span>
                </div>
                <p class="text-sm">Your trusted partner in making your study abroad dreams a reality.</p>
            </div>

            <!-- Quick Links -->
            <div>
                <h5 class="font-bold text-gray-800 mb-4">Quick Links</h5>
                <ul class="space-y-2 text-sm">

                <router-link to="/" 
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'home' }">
                    Home
                </router-link>

                <router-link to="/about"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'about' }">
                    About Us
                </router-link>

                <router-link to="/services"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'services' }">
                    Immigration Services
                </router-link>

                <!-- <router-link to="/blog"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'blog' }">
                    Blog
                </router-link> -->

                <router-link to="/contact"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'contact' }">
                    Contact Us
                </router-link>
<!--  -->
                </ul>
            </div>

            <!-- Contact Us -->
            <div>
                <h5 class="font-bold text-gray-800 mb-4">Contact Us</h5>
                <ul class="space-y-2 text-sm">
                    <li>123 University Ave, Suite 400, Toronto, ON, Canada</li>
                    <li>swifstudyabroad@gmail.com</li>
                    <li>+1 (416) 555-0142</li>
                </ul>
            </div>

            <!-- Follow Us (Inline SVG icons for social media) -->
            <div>
                <h5 class="font-bold text-gray-800 mb-4">Follow Us</h5>
                <div class="flex space-x-4">
                    <!-- Instagram/Meta Icon -->

                    <a href="https://www.instagram.com/swif_study_abroad_consultancy/" class="text-gray-500 hover:text-primary transition">
                       <ion-icon name="logo-instagram"></ion-icon>
                    </a>
                    <!-- Twitter/X Icon -->
                    <a href="https://x.com/swifstudy" class="text-gray-500 hover:text-primary transition">
                     <ion-icon name="logo-twitter"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
        <!-- Copyright -->
        <div class="container mx-auto px-4 mt-8 text-center text-xs text-gray-500">
            &copy; 2025 Swif Study Abroad. All rights reserved.
        </div>
    </footer>
</template>
